import { render, staticRenderFns } from "./ListIntegration.vue?vue&type=template&id=2d172679&scoped=true&"
import script from "./ListIntegration.vue?vue&type=script&lang=js&"
export * from "./ListIntegration.vue?vue&type=script&lang=js&"
import style0 from "./ListIntegration.vue?vue&type=style&index=0&id=2d172679&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d172679",
  null
  
)

export default component.exports